export default __webpack_public_path__ + "static/media/20.63c4c4f0.jpg";